
const badgeStyle = (bg, color) => ({
    background: bg, color, border: `1px solid ${color}44`,
    borderRadius: "12px", padding: "2px 10px",
    fontSize: "11px", fontWeight: 600,
});

const cardIconStyle = (bg, color) => ({
    width: "36px", height: "36px", borderRadius: "8px",
    background: bg, display: "flex", alignItems: "center",
    justifyContent: "center", fontSize: "18px",
    border: `1px solid ${color}22`,
});


const getBtnStyle = ({
    bg = "#2e7d32",
    disabled = false,
    alignSelf = "auto",
    color = "#fff",
}) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "9px 20px",
    borderRadius: "6px",
    border: "none",
    color,
    fontWeight: 600,
    fontSize: "13px",
    height: "26px",
    transition: "all 0.2s ease",
    background: disabled ? "#90a4ae" : bg,
    cursor: disabled ? "not-allowed" : "pointer",
    alignSelf,
});

const getResultCardStyle = ({
    background = "#fff",
    borderColor = "#c0dd97",
    leftBorderColor = "#5aad1e",
    borderRadius = "10px",
    padding = "0",
    marginTop = "0",
    textColor = "inherit",
    overflow = "hidden",
    animate = true,
    fontSize = "13px",
}) => ({
    background,
    border: `0.5px solid ${borderColor}`,
    borderLeft: `4px solid ${leftBorderColor}`,
    borderRadius,
    overflow,
    padding,
    marginTop,
    color: textColor,
    fontSize,
    animation: animate ? "sandwich-fade-in 0.3s ease" : "none",
});


const spinnerStyle = {
    display: "inline-block", width: "12px", height: "12px",
    border: "2px solid #ffffff55", borderTop: "2px solid #fff",
    borderRadius: "50%", animation: "spin 0.7s linear infinite",
};

export { badgeStyle, cardIconStyle, getBtnStyle, getResultCardStyle, spinnerStyle }
